var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg1 = function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 40,
    viewBox: "0 0 18 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.9768L8.93496 6.05217L0.853659 10.2725L2.44715 4.1971L10.5285 0H17.5L6.97154 40H0V39.9768Z",
    fill: "url(#paint0_linear_156_2373)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_2373",
    x1: 8.75,
    y1: 0,
    x2: 8.75,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0069FF",
    stopOpacity: 0
  })))));
};
export { Svg1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAxOCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMzkuOTc2OEw4LjkzNDk2IDYuMDUyMTdMMC44NTM2NTkgMTAuMjcyNUwyLjQ0NzE1IDQuMTk3MUwxMC41Mjg1IDBIMTcuNUw2Ljk3MTU0IDQwSDBWMzkuOTc2OFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNTZfMjM3MykiIGZpbGwtb3BhY2l0eT0iMC4zIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTU2XzIzNzMiIHgxPSI4Ljc1IiB5MT0iMCIgeDI9IjguNzUiIHkyPSI0MCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDA2OUZGIiBzdG9wLW9wYWNpdHk9IjAuNSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDY5RkYiIHN0b3Atb3BhY2l0eT0iMCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";